import type { AttractionCategory } from '@/config/objects/attraction-categories';
import { useOutletContext } from 'react-router-dom';

interface AttractionCategoryContext {
  attractionCategory: AttractionCategory | undefined;
  isLoading: boolean;
}

export function useAttractionCategoryContext() {
  return useOutletContext<AttractionCategoryContext>();
}
